import { removeNonDigits } from "./mask-util"

export const phoneValidationRegex: RegExp = /^[2-9]{1}[0-9]{9}$/;

// Returns phone number in the E.164 format, containing the initial '+' and country code
export const toE164 = (phoneNumber: string): string => {
    let cleaned = removeNonDigits(phoneNumber);
    switch (cleaned.length) {
        case 10:
            return `+1${cleaned}`;
        case 11:
            return `+${cleaned}`;
        case 12:
            return cleaned;
    }
    throw new Error('Unexpected phone length');
}

// Returns phone number with country code, without the initial '+'
export const fromE164 = (phoneNumber: string): string => {
    if (phoneNumber.length !== 12) {
        throw new Error('Unexpected phone length');
    }
    return phoneNumber.substring(1);
}

// Returns phone number without country code
export const removeCountryCode = (phoneNumber: string) : string => {
    let cleaned = removeNonDigits(phoneNumber);
    switch (cleaned.length) {
        case 10:
            return cleaned;
        case 11:
            return cleaned.substring(1);
        case 12:
            return cleaned.substring(2);
    }
    throw new Error('Unexpected phone length');
}
